module.exports = __webpack_public_path__ + "img/ic-white-percursos.d12af2ff.svg";